import { ref, readonly } from 'vue';
// Estado global reativo compartilhado entre componentes
const datepickerConfig = ref({
    allowCurrentDay: false,
    removeShortcutIds: [],
    defaultShortcutId: undefined,
});
export function useDatepickerConfig() {
    const setConfig = (config) => {
        datepickerConfig.value = {
            ...datepickerConfig.value,
            ...config,
        };
    };
    const resetConfig = () => {
        datepickerConfig.value = {
            allowCurrentDay: false,
            removeShortcutIds: [],
            defaultShortcutId: undefined,
        };
    };
    return {
        config: readonly(datepickerConfig),
        setConfig,
        resetConfig,
    };
}
